import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  CircularProgress,
  Typography
} from '@mui/material';
import { prestadorFetch } from '../../contexts/PrestadorAuthContext';
import { STATUS_NOTA_PORTAL } from '../../constants/prestadorDocumentos';
import PrestadorGraficosPanel from './PrestadorGraficosPanel';

const formatMoeda = (v) =>
  v != null ? Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '—';

export default function PrestadorNotasHistorico() {
  const [loading, setLoading] = useState(true);
  const [notas, setNotas] = useState([]);
  const [graficos, setGraficos] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const [rN, rG] = await Promise.all([
          prestadorFetch('/api/prestador/notas-fiscais/historico'),
          prestadorFetch('/api/prestador/graficos')
        ]);
        if (!cancelled) {
          setNotas(rN.ok ? await rN.json() : []);
          setGraficos(rG.ok ? await rG.json() : null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <PrestadorGraficosPanel dados={graficos} loading={false} />

      <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2 }}>
        Histórico de notas fiscais
      </Typography>

      {notas.length === 0 ? (
        <Typography color="text.secondary">Nenhuma nota fiscal registrada nos seus contratos.</Typography>
      ) : (
        <Paper sx={{ overflow: 'auto' }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Competência</TableCell>
                <TableCell>Contrato</TableCell>
                <TableCell>Nº NF</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right">Bruto</TableCell>
                <TableCell align="right">Líquido</TableCell>
                <TableCell align="right">Impostos</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {notas.map((n) => (
                <TableRow key={n.id}>
                  <TableCell>{n.competencia}</TableCell>
                  <TableCell>{n.numeroContrato}</TableCell>
                  <TableCell>{n.numeroNotaFiscal || '—'}</TableCell>
                  <TableCell>
                    <Chip size="small" label={STATUS_NOTA_PORTAL[n.status] || n.status} />
                  </TableCell>
                  <TableCell align="right">{formatMoeda(n.valorBruto)}</TableCell>
                  <TableCell align="right">{formatMoeda(n.valorLiquido)}</TableCell>
                  <TableCell align="right">{formatMoeda(n.valorImpostos)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}
    </Box>
  );
}
